import React, { Component } from 'react';
import {BrowserRouter,Route,Link} from 'react-router-dom';
import { connect } from 'react-redux';
import classes from './Deliveries.css';
import Table from '../../components/UI/Table/Table';
import Spinner from '../../components/UI/Spinner/Spinner';
import * as actions from '../../store/actions/index';

class Deliveries extends Component {
  componentDidMount() {
    this.props.onGetDeliveries();
  }

  state = {
    showEdit: false,
    showAdd: false,
    deliveryId: 0,
    width: window.innerWidth,
    delivery: null
  }

  cancelEditHandler = () => {
    this.setState({ showEdit: false, deliveryId: 0, delivery: null});
  }

  cancelAddHandler = () => {
    this.setState({ showAdd: false});
  }

  showAddHandler = () => {
    this.setState({ showAdd: true});
  }

  editDelivery = (e) => {
    let oid = e.currentTarget.getAttribute('oid');
    this.props.history.push('/addDelivery?' + oid);
  }


  render() {
     //this.props.history.push('/addDelivery?66');
    if (!this.props.loading) {

      var data = [];
      let pl = "30px";
      let fifty = "50px";
      let hundred = "100px";
      let oneFifty = "150px";
      let seventyFive = "75px";

      if (window.innerWidth < 500) {
        pl = "5px";
        fifty = "40px";
        hundred = "75px";
        oneFifty = "100px";
        seventyFive = "50px";
      }

      this.props.deliveries.map(del => (

        data.push({
          oid: del.deliveryId, data: [{
            value: del.deliveryId,
            style: { paddingLeft: pl},
            full: false
          },
          {
            value: del.name,
            style: { paddingLeft: pl },
            full: false
          },
          {
            value: del.phone,
            style: { paddingLeft: pl },
            full: false
          },
          {
            value: del.status,
            style: { paddingLeft: pl },
            full: true
          },
          {
            value: del.hardwoodBags,
            style: { paddingLeft: pl },
            full: false
          },
          {
            value: del.cedarBags,
            style: {  paddingLeft: pl },
            full: false
          },
          {
            value: del.blackBags,
            style: { paddingLeft: pl },
            full: false
          },
          {
            value: del.redBags,
            style: { paddingLeft: pl },
            full: false
          },
          {
            value: del.hardwoodBags + del.cedarBags + del.blackBags + del.redBags,
            style: { paddingLeft: pl },
            full: false
          }
          ]
        }
        )));



      var header = [{
        name: "Delivery",
        style: { paddingLeft: pl }
      },
      {
        name: "Name",
        style: { paddingLeft: pl }
      },
      {
        name: "Phone",
        style: {  paddingLeft: pl },
        full: true
      },
      {
        name: "Status",
        style: { paddingLeft: pl },
        full: true
      },
      {
        name: "Hwd",
        style: {  paddingLeft: pl }
      },
      {
        name: "Cdr",
        style: {  paddingLeft: pl }
      },
      {
        name: "Blk",
        style: {  paddingLeft: pl }
      },
      {
        name: "Red",
        style: { paddingLeft: pl }
      },
      {
        name: "Total",
        style: { paddingLeft: pl }
      }
      ];


      return (
          <Table header={header} data={data} editPopupHandler={this.editDelivery}></Table>
        );
    }
    else if (this.props.loading) {
      return (
        <div>
                
                <Spinner />
        </div>
      );
    }
    else {
      return (
        <div>
                
                <Spinner />
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    searchCriteria: state.orders.searchCriteria,
    deliveries: state.orders.deliveries,
    loading: state.orders.loading,
    purchased: state.orders.purchased,
    scoutsLastGot: state.orders.scoutsLastGot
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetDeliveries:() => dispatch(actions.getDeliveries())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Deliveries);


// WEBPACK FOOTER //
// ./src/containers/Deliveries/Deliveries.js